module.exports = __webpack_public_path__ + "static/media/KaiZenDifferent.075525bf.jpg";